// Copyright (c) 2024 by Audere

import { LabelTask } from "../../label/labelTypes";
import {
  commonLabelingTasks,
  commonLabelingTypes,
  commonQuestions,
  translationLabelingTask,
  translationQuestions,
} from "./common";

export const proteaLabelingTypes = [
  ...commonLabelingTypes,
  {
    id: "isiZuluTranslationLabeling",
    name: "Translation labeling isiZulu",
    description: "Label the translation quality of isiZulu language",
    taskIDs: ["qualityOfTranslationLabeling"],
  },
] as const;

const proteaLabelingTasks: LabelTask[] = [
  ...commonLabelingTasks,
  ...translationLabelingTask,
];

const proteaQuestions = [...commonQuestions, ...translationQuestions];

export const proteaLabelingSchemaV1 = {
  labelingTypes: proteaLabelingTypes,
  labelingTasks: proteaLabelingTasks,
  labelingQuestions: proteaQuestions,
  labelingSchemaVersion: "proteaLabelingSchemaV1",
};
